import { render, staticRenderFns } from "./CurrencyRatesEditModal.vue?vue&type=template&id=2deb55b8"
import script from "./CurrencyRatesEditModal.vue?vue&type=script&lang=js"
export * from "./CurrencyRatesEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports